import {until} from 'lit-html/directives/until';
import '../../../modules/dropdown';
import {LoadingEllipses} from '@epg/epg-components';
import '../modules/license-info';
import '../modules/inventory-allocation';


export default (ctx, html) => {
  if (ctx.loading) {
    return html`
      <div class="d-flex justify-content-center">
        <loading-ellipses></loading-ellipses>
      </div>
    `;
  }

  return html`
    <div class="row mb-5">
      <div class="col-sm-10">
        <h1 class="h2">${until(ctx.__('<tt-Q6j2maoF>', 'License Management:'))} ${until(ctx._r(ctx.__('<tt-F94S7QyO>', '%r1%'), ctx.licenseInfo?.name))}</h1>
      </div>
    </div>

    <license-info @scroll-to="${ctx.scrollTo}"></license-info>
    ${ctx.childGroupsLicenseCount.total > 0 || ctx.childGroupsLicenseCount.assigned > 0 || ctx.childGroupsLicenseCount.available > 0 || ctx.childGroupsLicenseCount.redeemed > 0 ? html`
          <inventory-allocation id="inventory-allocation"></inventory-allocation>` : ''}
  `;
};
